/**
 * D7 A8：即時通訊品牌 icon（簡化品牌色圓角＋氣泡；Kakao 為黃底深色氣泡）。
 * 以品牌色 + 統一氣泡造型呈現，清楚可辨、風格一致，避免不精確的仿製標誌。
 */
type IconProps = { className?: string };

const BUBBLE =
  "M12 6.3c-3.4 0-6.2 2.2-6.2 4.9 0 1.7 1.1 3.2 2.9 4-.1.5-.5 1.6-.6 1.9 0 .2.1.3.3.2.1-.1 1.8-1.2 2.5-1.7.4.1.8.1 1.1.1 3.4 0 6.2-2.2 6.2-4.9S15.4 6.3 12 6.3Z";

function BrandChip({ bg, fg = "#ffffff", className = "" }: { bg: string; fg?: string; className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className || "h-4 w-4"} aria-hidden="true">
      <rect width="24" height="24" rx="6" fill={bg} />
      <path d={BUBBLE} fill={fg} />
    </svg>
  );
}

export const WhatsAppIcon = (p: IconProps) => <BrandChip bg="#25D366" {...p} />;
export const LineIcon = (p: IconProps) => <BrandChip bg="#06C755" {...p} />;
export const WechatIcon = (p: IconProps) => <BrandChip bg="#07C160" {...p} />;
export const KakaoIcon = (p: IconProps) => <BrandChip bg="#FEE500" fg="#3C1E1E" {...p} />;
